import styled from "@emotion/styled";

export const Wrapper = styled.div`
  aspect-ratio: var(--Media-aspect-ratio, 16 / 9);
  overflow: hidden;
`;
